const menuButton = document.getElementById('menuToggle');
const menuOverlay = document.getElementById('menuOverlay');
const menuLinks = menuOverlay ? menuOverlay.querySelectorAll('a') : [];

function openMenu() {
  menuButton.classList.add('is-open');
  menuOverlay.classList.add('is-open');
  document.body.classList.add('menu-open');

  menuButton.setAttribute('aria-expanded', 'true');
  menuButton.setAttribute('aria-label', 'Close menu');
  menuOverlay.setAttribute('aria-hidden', 'false');
}

function closeMenu() {
  menuButton.classList.remove('is-open');
  menuOverlay.classList.remove('is-open');
  document.body.classList.remove('menu-open');

  menuButton.setAttribute('aria-expanded', 'false');
  menuButton.setAttribute('aria-label', 'Open menu');
  menuOverlay.setAttribute('aria-hidden', 'true');
}

function toggleMenu() {
  if (menuOverlay.classList.contains('is-open')) {
    closeMenu();
  } else {
    openMenu();
  }
}

if (menuButton && menuOverlay) {
  menuButton.addEventListener('click', toggleMenu);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
    }
  });

  menuLinks.forEach((link) => {
    link.addEventListener('click', closeMenu);
  });
}
